


const DatesSection = {
  
  "MonthsSection" : 1,
  "CalendarSection" : 2
}


const SearchByDates = {
  "Months" : 1,
  "Range" : 2
}

const getDaysInMonth = (month,year) => {
   return new Date(year, month, 0).getDate();
};


const getDayOfWeek = (day,month,year) => {
    return new Date(year, month-1, day).getDay() ;
 };



 const  hebMonthName = (num) =>  { 

  switch (num) {
      case 1:
          return 'ינואר';
      case 2:
          return 'פברואר';
      case 3:
          return 'מרץ';
      case 4:
          return 'אפריל';
      case 5:
          return 'מאי';
      case 6:
          return 'יוני';

      case 7:
          return 'יולי';
      case 8:
          return 'אוגוסט';
      case 9:
          return 'ספטמבר';
      case 10:
          return 'אוקטובר';
      case 11:
          return 'נובמבר';
      case 12:
          return 'דצמבר';

      default:
          return '';
 };
};



const setDay = (key, thisday, month, year,disabled) => {
  let d = {};
  d.thisDay = thisday;
  //d.date = thisday + '.' + month + "." + year;
  d.date = thisday + '/' + month + "/" + year;
  d.TDate = new Date(year, month-1, thisday)
  d.disabled = disabled;
  d.selected = false;
  d.key = key;
  return d;
}






const setMonth = (currMonth, currYear) => {
        


  var startDayInFirstWeek = getDayOfWeek(1,currMonth,currYear);    
  var lastDay = getDaysInMonth(currMonth,currYear);    

  var daysPrevMonth = getDaysInMonth(currMonth - 1,currYear);            
  var currDayPrevMonth = daysPrevMonth - startDayInFirstWeek + 1;    
  var currDay = 1;
  var currDayNextMonth = 1;
  var key = 1;
  
  var w1 = [7];
  var w2 = [7];
  var w3 = [7];
  var w4 = [7];
  var w5 = [7];
  var w6 = [7];



  var i;

  for (i = 0; i < 7; i++) {
    if (i >= startDayInFirstWeek) {      
      w1[i] = setDay(key,currDay,currMonth,currYear, );
      currDay = currDay + 1;            
    } else {      
      w1[i] = setDay(key,currDayPrevMonth,currMonth,currYear,true);   
      currDayPrevMonth = currDayPrevMonth + 1; 
    }

    key = key +1;
  }    

  for (i = 0; i < 7; i++) {                      
    w2[i] = setDay(key,currDay,currMonth,currYear,false);
    currDay = currDay + 1;
    key = key +1;
  }    

  for (i = 0; i < 7; i++) {
      w3[i] = setDay(key,currDay,currMonth,currYear,false);
      currDay = currDay + 1;
      key = key +1;
    }    
  for (i = 0; i < 7; i++) {
      w4[i] = setDay(key,currDay,currMonth,currYear,false);
      currDay = currDay + 1;
      key = key +1;  
  }    

  for (i = 0; i < 7; i++) {
    if ( currDay <= lastDay) {            
      w5[i] = setDay(key,currDay,currMonth,currYear,false);
      currDay = currDay + 1;        
    } else {            
      w5[i] = setDay(key,currDayNextMonth,currMonth,currYear,true);
      currDayNextMonth = currDayNextMonth + 1;
    }

    key = key +1;  
  }    

  for (i = 0; i < 7; i++) {
    if ( currDay <= lastDay) {            
      w6[i] = setDay(key,currDay,currMonth,currYear,false);
      currDay = currDay + 1;        
    } else {            
      w6[i] = setDay(key,currDayNextMonth,currMonth,currYear,true);
      currDayNextMonth = currDayNextMonth + 1;
    }

    key = key +1;  
  }    


  return {
    week1 : w1,
    week2 : w2,
    week3 : w3,
    week4 : w4,
    week5 : w5,
    week6 : w6,
  }
}










export {
  getDaysInMonth,
  getDayOfWeek,
  hebMonthName,
  setDay,
  setMonth,
  DatesSection,
  SearchByDates
}
